export default "__VITE_ASSET__BQPY1xiv__"